import { Navigate } from 'react-router-dom';
import { DEFAULT_LOCALE, localeExists } from '../../helpers/intl';

function MainPage() {
    const locale = navigator.language.split(/[-_]/)[0];
    return <Navigate replace to={`/${localeExists(locale) ? locale : DEFAULT_LOCALE}`} />;
}

export default MainPage;
